<template lang="pug">
#analisar-operacao
    div(v-show='mostrarFormulariosOperacao')
        BaseHeader(
            :titulo="$t('mensagens.operacao.analisar')",
            :voltarPara="true"
            :exibeBotao='false'
        )
            template(slot='direita')
                el-dropdown(trigger='click')
                        BaseButton.analisar-operacao__header__acao__botao(
                            type='primary'
                        )
                            i.el-icon-arrow-down
                            span {{ $t('mensagens.operacao.tabela.acoes') }}
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='flow flow-environment',
                                @click.native='realizarAnaliseSocioambiental()'
                            ) {{ $t('mensagens.operacao.acoes.realizarAnalise') }}

        .view-container-base-header
            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.dadosGerais') }}
            FormularioDadosGeraisOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                ref='refFormularioDadosGerais',
                @dadosGerais='atualizarDadosGerais',
                :operacaoEditarOuClonar='operacaoEditar'
            )

            .titulo-card
                span(v-if='atividadeObrigatoria') {{ $t('mensagens.operacao.atividades') }}
            FormularioAtividadeOperacao(
                class='mb-4',
                v-if='atividadeObrigatoria && verificouSeEcadastroOuEdicao',
                @dadosAtividades='atualizarAtividades',
                :operacaoEditarOuClonar='operacaoEditar',
                :atividadeObrigatoria='atividadeObrigatoria'
            )

            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.pessoaGrupoEconomico') }}
            FormularioPessoaOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                @dadosPessoa='atualizarPessoa',
                :operacaoEditarOuClonar='operacaoEditar',
            )

            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.territorioGleba') }}
            FormularioTerritorioGlebaOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                @dadosTerritorioGleba='atualizarTerritorioGleba',
                :dadosEditarOuClonar='operacaoEditar',
                :dadosValidarSobreposicao='validarSobreposicao'
            )

            section.analisar-operacao__acao.mt-3
                BaseButton.mr-2(size='small', @click='$router.go(-1)')
                    | {{ $t('mensagens.comuns.voltar') }}

                BaseButton(
                    @click='realizarAnaliseSocioambiental()',
                    type='primary',
                    size='small'
                )
                    | {{ $t('mensagens.operacao.acoes.realizarAnalise') }}

    CardAnaliseSocioambientalOperacao(
        v-if='mostrarCardAnaliseSocioambiental',
        habilitar-analise,
        :habilitar-botao-cadastrar='false',
        :dadosDiagnostico='dadosAnaliseSocioambientalProtocolo',
        @aprovarOperacao='aprovarOperacao',
        @reprovarOperacao='reprovarOperacao',
        @cadastrarOperacao='salvarEdicaoOperacao',
        @fechar='fecharCardAnaliseSocioambientalOperacao'
    )

    .modal-sobreposicao
        el-dialog(
            :visible.sync='mostrarModalSobreposicao',
            :close-on-click-modal='false',
            :close-on-press-escape='false',
            :destroy-on-close='true',
            :before-close='fecharModalSobreposicao',
            width='35vw'
        )
            template(slot='title')
                .box-header
                    .box-header--icon
                        i.mdi.mdi-alert-circle-outline
                    .box-header--title
                        | Sobreposição encontrada
                span Intersecção entre glebas com tipo não permitido.

            .modal-sobreposicao__list
                .modal-sobreposicao-list__content
                    .modal-sobreposicao-list__item.is-always-shadow(
                        v-for='(gleba, glebaIndex) in operacoesSobreposicao',
                        :key='glebaIndex'
                    )
                        .modal-sobreposicao-list__mapa(:id='gleba.id')
                        div
                            span.titulo-tabela Operação:
                            span {{ gleba.operacaoNome }}
                        div
                            span.titulo-tabela Identificador da operação:
                            span {{ gleba.operacaoIdentificador }}
                        div
                            span.titulo-tabela Identificador da gleba:
                            span {{ gleba.operacaoIdentificadorGleba }}
                        div
                            span.titulo-tabela Área da sobreposição (ha):
                            span {{ gleba.areaSobreposicao }}

                    div(v-if='!operacoesSobreposicao.length')
                        .lista-vazia
                            el-empty(
                                :image-size='100',
                                description='Nenhuma gleba foi encontrada'
                            )
            span.formulario-territorio-gleba-operacao--modal__sobreposicao__footer(
                slot='footer'
            )
                BaseButton.mt-3(@click='fecharModalSobreposicao()') Voltar
</template>

<script>
import L from 'leaflet';
import BaseHeader from '@/components/BaseHeader';
import CardAnaliseSocioambientalOperacao from '@/components/operacao/gestao/CardAnaliseSocioambientalOperacao.vue';
import FormularioTerritorioGlebaOperacao from '@/components/operacao/gestao/FormularioTerritorioGlebaOperacao.vue';
import FormularioDadosGeraisOperacao from '@/components/operacao/gestao/FormularioDadosGeraisOperacao.vue';
import FormularioAtividadeOperacao from '@/components/operacao/gestao/FormularioAtividadeOperacao.vue';
import FormularioPessoaOperacao from '@/components/operacao/gestao/FormularioPessoaOperacao.vue';
import OperacaoService from '@/services/OperacaoService';
import ExceptionMapper from '@/utils/exceptionMapper';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';
import { DEFAULT_CONFIG, TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config.js';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

const ID_PAPEL_BENEFICIARIO = 8;

export default {
    name: 'AnalisarOperacao',

    components: {
        BaseHeader,
        CardAnaliseSocioambientalOperacao,
        FormularioDadosGeraisOperacao,
        FormularioAtividadeOperacao,
        FormularioPessoaOperacao,
        FormularioTerritorioGlebaOperacao,
        BaseButton
    },

    data() {
        return {
            operacaoEditar: null,
            acao: 'ANALISAR',
            operacoesSobreposicao: [],
            mostrarModalSobreposicao: false,
            labelOperacaoSobreposicao: '',
            validarSobreposicao: {
                idOperacao: null,
                idCategoria: null,
                datasPlantio: []
            },
            atividadeObrigatoria: true,
            dadosAnaliseSocioambientalProtocolo: {
                pessoas: [],
                territorios: [],
                glebas: [],
                idOperacao: null
            },
            operacao: {
                dadosGerais: null,
                atividades: [],
                pessoasGrupoEconomico: [],
                territoriosGlebas: []
            },
            verificouSeEcadastroOuEdicao: false,
            mostrarFormulariosOperacao: true,
            mostrarCardAnaliseSocioambiental: false
        };
    },

    async mounted() {
        await OperacaoService.buscarPorId(this.$route.params.id)
            .then(({ data }) => {
                this.operacaoEditar = data;
                this.validarStatusOperacao(data);
                this.verificouSeEcadastroOuEdicao = true;
            })
            .catch(error => {
                this.$notify.error({
                    message: error.message
                });
                this.$router.push({ name: 'operacao' });
            });

        if (this.$route.params.id) {
            this.validarSobreposicao.idOperacao = this.$route.params.id;
            this.dadosAnaliseSocioambientalProtocolo.idOperacao = this.$route.params.id;

        } else {
            this.validarSobreposicao.idOperacao = null;
            this.dadosAnaliseSocioambientalProtocolo.idOperacao = null;
        }
    },

    methods: {
        validarStatusOperacao(data) {
            if (
                data.analise.codigo !== 'AGUARDANDO_APROVACAO' &&
                data.analise.codigo !== 'EM_ANALISE'
            ) {
                throw new Error(
                    this.$t('mensagens.operacao.notificacao.operacaoNaoPodeSerAnalisada')
                );
            }
        },

        atualizarDadosGerais(dadosGerais) {
            this.operacao.dadosGerais = dadosGerais;
            if (this.operacao.dadosGerais.categoria) {
                this.atividadeObrigatoria =
                    this.operacao.dadosGerais.categoria.atividadeObrigatoria;
            }
            this.validarSobreposicao.idCategoria = dadosGerais.categoria.id;
        },

        atualizarPessoa(dadosPessoas) {
            this.operacao.pessoasGrupoEconomico = dadosPessoas;
        },

        atualizarAtividades(dadosAtividades) {
            this.operacao.atividades = dadosAtividades;
            this.validarSobreposicao.datasPlantio = [];
            this.operacao.atividades.forEach(atividade => {
                if (atividade.inicioPlantio) {
                    this.validarSobreposicao.datasPlantio.push(
                        atividade.inicioPlantio
                    );
                }
            });
            this.dadosAnaliseSocioambientalProtocolo = {
                ...this.dadosAnaliseSocioambientalProtocolo,
                atividades: this.operacao?.atividades
            };
        },

        atualizarTerritorioGleba(territoriosGlebas) {
            this.operacao.territoriosGlebas = territoriosGlebas;
        },

        async aprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();

            if (idOperacaoGerada) {
                await OperacaoService.aprovar(idOperacaoGerada, payload)
                    .then(() => {
                        this.$notify.success({
                            message: this.$t('mensagens.operacao.notificacao.operacaoAprovada')
                        });
                        this.$router.push({ name: 'operacao' });
                        this.mostrarCardAnaliseSocioambiental = false;
                    })
                    .catch((err) => {

                        if (err.response?.data) {
                            
                            const errorMessage = err.response.data === '[ERRO_PDF]' ? this.$t('mensagens.operacao.notificacao.erroPdf') : err.response.data;
                            
                            this.$notify.error({
                                message: errorMessage,
                                duration: 15000
                            });
                            return;
                        }

                        this.$notify.error({
                            message:
                                this.$t('mensagens.operacao.notificacao.verificarDadosAprovacao'),
                            duration: 15000
                        });
                    });
            }
        },

        async reprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();

            if (idOperacaoGerada) {
                await OperacaoService.reprovar(idOperacaoGerada, payload)
                    .then(() => {
                        this.$notify.success({
                            message: this.$t('mensagens.operacao.notificacao.operacaoReprovada')
                        });
                        this.$router.push({ name: 'operacao' });
                        this.mostrarCardAnaliseSocioambiental = false;
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.impossivelReprovarOperacao')
                        });
                    });
            }
        },

        async realizarAnaliseSocioambiental() {
            if (!(await this.validarFormularios())) return;

            this.dadosAnaliseSocioambientalProtocolo = {
                pessoas: [],
                territorios: [],
                idOperacao: this.$route.params.id,
                idCategoria: this.operacao.dadosGerais.categoria.id
            };

            const setPessoa = new Set();

            const pessoasUnicas = this.operacao.pessoasGrupoEconomico.filter(
                pessoa => {
                    const duplicada = setPessoa.has(pessoa.cpfCnpj);
                    setPessoa.add(pessoa.cpfCnpj);
                    return !duplicada;
                }
            );

            pessoasUnicas
                .map(e => ({
                    cpfCnpj: e.cpfCnpj,
                    nomeRazaoSocial: e.nomeRazaoSocial
                }))
                .forEach(e => {
                    this.dadosAnaliseSocioambientalProtocolo.pessoas.push(e);
                });

            this.operacao.territoriosGlebas.forEach(territorio => {
                const glebas = territorio.glebas.map(gleba => {
                    return {
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        geometria: gleba.geometria,
                        nome: gleba.nome,
                        areaHa: gleba.areaHa,
                        idTipo: gleba.idTipo
                    };
                });

                this.dadosAnaliseSocioambientalProtocolo.territorios.push({
                    idTerritorio: territorio.idTerritorio,
                    nomeTerritorio: territorio.nomeTerritorio,
                    glebas
                });
            });

            this.dadosAnaliseSocioambientalProtocolo.idOperacao = this.$route.params.id;

            this.dadosAnaliseSocioambientalProtocolo = {
                ...this.dadosAnaliseSocioambientalProtocolo,
                atividades: this.operacao?.atividades
            };

            this.mostrarFormulariosOperacao = false;
            this.mostrarCardAnaliseSocioambiental = true;
        },

        fecharCardAnaliseSocioambientalOperacao() {
            this.mostrarFormulariosOperacao = true;
            this.mostrarCardAnaliseSocioambiental = false;
        },

        async salvarEdicaoOperacao() {
            if (!(await this.validarFormularios())) return;

            if (this.operacao.dadosGerais.valorTotalOperacao === 0) {
                this.operacao.dadosGerais.valorTotalOperacao = null;
            }

            return OperacaoService.editar(
                this.operacao,
                this.operacaoEditar.dadosGerais.id
            )
                .then(({ data }) => data.idOperacaoGerada)
                .catch(err => {
                        if (err.response?.status === 409) {
                            this.$notify.error({
                                message: this.$t('mensagens.operacao.notificacao.conflitoEditar')
                            });
                            return;
                        }

                        if (err.response?.data?.message) {
                            
                            const errorMessage = err.response.data.message === '[ERRO_PDF]' ? this.$t('mensagens.operacao.notificacao.erroPdf') : err.response.data.message;
                            
                            this.$notify.error({
                                message: errorMessage,
                                duration: 15000
                            });
                            return;
                        }

                        if (ExceptionMapper(err)) {
                            this.$notify.error({
                                message: err.response.data.message,
                                duration: 15000
                            });
                        }
                    }
                );
        },

        async validarFormularios() {
            if (
                !(await this.$refs.refFormularioDadosGerais.validarFormulario())
            ) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioDadosGerais')
                });
                return false;
            }

            if (
                this.operacao.atividades.length === 0 &&
                this.operacao.dadosGerais.categoria.id < 4
            ) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.campoObrigatorioAtividades')
                });
                return false;
            }

            if (this.operacao.pessoasGrupoEconomico.length === 0) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioGrupoEconomico')
                });
                return false;
            }

            if (this.operacao.territoriosGlebas.length === 0) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioTerritorio')
                });
                return false;
            }

            if (
                this.operacao.pessoasGrupoEconomico.filter(
                    ({ idPapel }) => idPapel === ID_PAPEL_BENEFICIARIO
                ).length === 0
            ) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.campoObrigatorioBeneficiario')
                });
                return false;
            }
            const valido = await this.validarSobreposicaoGlebas();
            return valido;

        },

        async validarSobreposicaoGlebas() {
            this.operacoesSobreposicao = [];

            await Promise.all(
                this.operacao.territoriosGlebas.map(async territorio => {
                    await Promise.all(
                        territorio.glebas.map(async gleba => {
                            const idTipoGleba = gleba.idTipo;
                            const geometria = gleba.geometria;

                            if (
                                (this.validarSobreposicao.idCategoria === 1 ||
                                    this.validarSobreposicao.idCategoria ===
                                        2) &&
                                this.validarSobreposicao.datasPlantio.length >
                                    0 &&
                                (idTipoGleba === 1 || idTipoGleba === 3)
                            ) {
                                const sobreposicao = {
                                    idOperacao:
                                        this.validarSobreposicao.idOperacao,
                                    geoJson: geometria,
                                    datasInicioPlantio: [],
                                    acao: this.acao,
                                    idsProdutos: this.operacao.atividades.map(atividade => atividade.idProduto)
                                };

                                this.validarSobreposicao.datasPlantio.forEach(
                                    plantio => {
                                        sobreposicao.datasInicioPlantio.push({
                                            data: plantio
                                        });
                                    }
                                );

                                try {
                                    const { data } =
                                        await OperacaoService.validarSobreposicaoGlebas(
                                            sobreposicao
                                        );

                                    this.operacoesSobreposicao.push(
                                        ...data.sobreposicoes
                                    );
                                } catch (error) {
                                    this.exibirNotify(
                                        'error',
                                        'Não foi possível validar sobreposições da gleba.'
                                    );
                                }
                            }
                        })
                    );
                })
            );

            if (this.operacoesSobreposicao.length > 0) {
                this.mostrarModalSobreposicao = true;

                this.labelOperacaoSobreposicao = 'operação';
                if (this.operacoesSobreposicao.length > 1) {
                    this.labelOperacaoSobreposicao = 'operações';
                }
                await this.criarMapaSobreposicao();
                return false;
            } else {
                return true;
            }
        },

        async criarMapaSobreposicao() {
            const sobreposicoes = await this.operacoesSobreposicao.sort(
                (a, b) => {
                    return a.identificador.localeCompare(b.identificador);
                }
            );

            sobreposicoes.forEach(sobreposicao => {
                const { id, geometria, territorioGeometria } = sobreposicao;
                this.criarMapaListaGleba(
                    id.toString(),
                    geometria,
                    territorioGeometria
                );
            });
        },

        criarMapaListaGleba(id, geometria, territorioGeometria) {
            var mapa = this.criarMapaBase(id);

            const layerGleba = L.geoJSON(geometria, {
                style: () => {
                    return getEstiloGeometria('operacaoGleba');
                }
            });

            const layerTerritorio = L.geoJSON(territorioGeometria, {
                style: () => {
                    return getEstiloGeometria('area');
                }
            });

            var grupo = new L.FeatureGroup();
            grupo.addLayer(layerTerritorio);

            // hack para a layer da gleba ficar na frente da layer do território
            setTimeout(() => {
                layerGleba.bringToFront();
            }, 0);

            grupo.addLayer(layerGleba);
            grupo.addTo(mapa);

            mapa.fitBounds(grupo.getBounds());

            mapa.dragging.disable();
            mapa.scrollWheelZoom.disable();
        },

        criarMapaBase(id) {
            const mapa = L.map(id, {
                maxZoom: DEFAULT_CONFIG.maxZoom,
                minZoom: DEFAULT_CONFIG.minZoom,
                zoomControl: false
            });

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attributionControl: false
            }).addTo(mapa);

            mapa.attributionControl.setPrefix('');

            return mapa;
        },

        fecharModalSobreposicao() {
            this.mostrarModalSobreposicao = false;
            this.operacoesSobreposicao = [];
        }
    }
};
</script>

<style lang="scss" scoped>
#analisar-operacao {
    height: 100%;
    width: 100%;

    .analisar-operacao__header__acao__botao {
        font-size: 14px;
        color: var(--white);
        background: var(--primary);
        border-color: var(--primary);
        border-radius: $default-border-radius;
        font-weight: map-get($font-weight, normal);
        padding: 12px 20px;
    }

    .analisar-operacao__header {
        margin: 0;
        align-items: center;
        padding: 20px;
        height: 100px;
        width: 100%;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .analisar-operacao__header__title {
            padding: 0;
            color: var(--primary-font-color);
            font-weight: map_get($font-weight, medium);
            font-size: map-get($font-size, x-large);

            .analisar-operacao__header__title--acao {
                cursor: pointer;
                margin-right: 10px;
                font-size: 22px;
            }
        }
    }

    .analisar-operacao__acao {
        display: flex;
        justify-content: space-between;
    }

    .titulo-card {
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 7px;
    }

    .modal-sobreposicao {
        .el-dialog__header {
            padding: initial !important;
            padding-bottom: initial !important;
            span {
                font-size: 12px;
                font-style: italic;
                font-weight: 600;
                color: #606266;
                margin: 20px 0;
                padding-left: 10px;
            }
        }

        .el-dialog__body {
            display: flex;
            padding: initial !important;
            color: #606266;

            #modal-sobreposicao__mapa {
                width: 100%;
                height: 100vh;
            }
            .modal-sobreposicao__list {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .modal-sobreposicao-list__content {
                    max-height: 88vh;
                    overflow-y: scroll;

                    h3 {
                        font-size: 16px;
                        color: #3b3b3b;
                        margin-bottom: 20px;
                    }

                    span {
                        margin-left: 5px;
                    }

                    .modal-sobreposicao-list__item {
                        margin-top: 15px;
                        border: 1px solid var(--black) 00021;
                        border-radius: 5px;
                        padding: 10px;
                        &:first-child {
                            margin-top: 0;
                        }

                        .modal-sobreposicao-list__mapa {
                            width: 100%;
                            height: 250px;

                            margin-bottom: 10px;
                        }

                        .modal-sobreposicao-list__button {
                            display: flex;
                            justify-content: flex-end;
                        }
                        strong {
                            font-size: 14px;
                        }

                        .titulo-tabela {
                            font-size: 14px;
                            font-weight: 600;
                        }

                        p {
                            font-size: 14px;
                            word-break: break-word;
                        }
                    }
                }

                .modal-sobreposicao__button {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                }
            }
        }

        .el-dialog__wrapper {
            top: -15px !important;
        }

        .el-dialog__header {
            background: var(--operation-awaiting-approval);
        }

        .box-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .box-header--icon {
                margin-right: 10px;
            }

            .box-header--title {
                color: var(--warning);
                font-size: 20px;
            }

            .mdi:before,
            .mdi-set {
                font-size: 19px;
                color: var(--warning);
            }
        }
    }
}
</style>
